// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import Icon_chain from '../../img/competitors/chain.svg';
import Icon_speed from '../../img/competitors/speed.svg';
import Icon_save from '../../img/competitors/save.svg';
import {Input} from '../../../../hola/pub/lib/input';
import styles from './feature_cards.module.less';
import {Dynamic_heading, Title_header_select} from '../../../../shared/editor/title_header_select';

interface i_feature_card {
    title: React.ReactNode;
    title_tag?: string;
    subtitle: string;
    bg_gradient: string;
    icon?: React.ReactNode;
}

interface i_feature_cards_props {
    cards?: {
        title: string;
        title_tag?: string;
        subtitle: string;
    }[];
    after_text?: string;
}

const default_cards = [
    {
        title: 'Higher Performance',
        subtitle: 'Faster, more stable connections with global IPs.',
        bg_gradient: 'blue',
        icon: <Icon_speed/>,
    },
    {
        title: 'Better Flexibility',
        subtitle: 'Pay-as-you-go pricing with no commitments.',
        bg_gradient: 'green',
        icon: <Icon_save/>,
    },
    {
        title: 'Advanced Features',
        subtitle: 'Real-time analytics and seamless integration.',
        bg_gradient: 'purple',
        icon: <Icon_chain/>,
    },
];

const Feature_card = ({title, subtitle, bg_gradient, icon}: i_feature_card)=>{
    const {theme} = useContext(Settings_context);
    return <div className={cn(styles.card, styles[`bg_${bg_gradient}`])}>
      {icon && <div className={styles.icon}>{icon}</div>}
      <div className={styles.content}>
        <p className={cn(theme.h18, theme.med)}>{title}</p>
        <p className={cn(theme.p16, theme.reg)}>{subtitle}</p>
      </div>
    </div>;
};

export const Feature_cards = (props: i_feature_cards_props)=>{
    const {theme} = useContext(Settings_context);
    const cards = default_cards.map((card, i)=>({
        ...card,
        title: <Dynamic_heading tag={props.cards?.[i]?.title_tag}>
          {props.cards?.[i]?.title || card.title}</Dynamic_heading>,
        subtitle: props.cards?.[i]?.subtitle || card.subtitle,
    }));
    const after_text = props.after_text ||
        'Join thousands of satisfied users who have made the switch!';
    return <section className={styles.feature_cards}>
      <div className={cn(theme.container, styles.container)}>
        <div className={styles.cards_wrapper}>
          {cards.map((card, i)=>
            <Feature_card key={i} {...card} />
          )}
        </div>
        <div className={styles.subtitle}>
          <p className={cn(theme.mono18, theme.med, theme.color_n600)}>
            {after_text}
          </p>
        </div>
      </div>
    </section>;
};

export const Feature_cards_editor = ({value, on_change})=>{
  const update_card = (index: number, field: string, new_value: string)=>{
      const new_cards = [...value.cards || []];
      if (!new_cards[index])
          new_cards[index] = {};
      new_cards[index] = {...new_cards[index], [field]: new_value};
      on_change({...value, cards: new_cards});
  };
  return <div>
    {default_cards.map((card, i)=>
      <div key={i}>
        <h4>Card {i + 1}</h4>
        <Input
          value={value.cards?.[i]?.title || card.title}
          on_change={v=>update_card(i, 'title', v)}
          label='Title'
        />
        <Title_header_select value={value.cards?.[i]?.title_tag
          || value.title_tag} on_select={v=>
          update_card(i, 'title_tag', v)}/>
        <Input
          value={value.cards?.[i]?.subtitle || card.subtitle}
          on_change={v=>update_card(i, 'subtitle', v)}
          label='Subtitle'
        />
      </div>
    )}
    <Input
      value={value.after_text || ''}
      on_change={v=>on_change({...value, after_text: v})}
      label='Bottom Text'
    />
  </div>;
};
